import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useGlobal } from "../../GlobalContext";

//SVG
import Dashboard from "../../assets/svg/dashboard.svg";
import Assets from "../../assets/svg/assets.svg";
import Checking from "../../assets/svg/checking.svg";
import Report from "../../assets/svg/report.svg";
import DashboardActive from "../../assets/svg/dashboardactive.svg";
import AssetsActive from "../../assets/svg/assetsactive.svg";
import CheckingActive from "../../assets/svg/checkingactive.svg";
import ReportActive from "../../assets/svg/reportactive.svg";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveFromPath = (path) => {
    if (path.startsWith("/asset")) return "assets";
    if (path.startsWith("/checking")) return "checking";
    if (path.startsWith("/report")) return "report";
    return "dashboard";
  };

  const [activeIcon, setActiveIcon] = useState(getActiveFromPath(location.pathname));

  useEffect(() => {
    setActiveIcon(getActiveFromPath(location.pathname));
  }, [location.pathname]);

  const { rolePermissionList, userType } = useGlobal();

  const isAdmin = userType === "Admin" || userType === "Org-Admin" || userType === "HR";

  const hasPermission = (menuName) => {
    if (isAdmin) return true;
    return rolePermissionList.findIndex((el) => el.name === menuName && el.menu_permission === true) > -1;
  };

  return (
    <div style={{ fontFamily: "Lexend Deca", height: "100%", padding: "10px", backgroundColor: "#2d3e50", display: "flex", flexDirection: "column", gap: "12px" }}>
      <div
        onClick={() => {
          setActiveIcon("dashboard");
          navigate("/dashboard");
        }}
      >
        <img src={activeIcon === "dashboard" ? DashboardActive : Dashboard} alt="dashboard" style={{ height: "44px", cursor: "pointer" }} title="Dashboard" />
      </div>

      {/* {hasPermission("Asset") && ( */}
        <div
          onClick={() => {
            setActiveIcon("assets");
            navigate("/asset");
          }}
        >
          <img src={activeIcon === "assets" ? AssetsActive : Assets} alt="assets" style={{ height: "44px", cursor: "pointer" }} title="Assets" />
        </div>
       {/* )} */}

      {/* {hasPermission("Checking") && ( */}
        <div
          onClick={() => {
            setActiveIcon("checking");
            navigate("/checking");
          }}
        >
          <img src={activeIcon === "checking" ? CheckingActive : Checking} alt="checking" style={{ height: "44px", cursor: "pointer" }} title="Checking" />
        </div>
      {/* )} */}

      {/* {hasPermission("Report") && ( */}
        <div
          onClick={() => {
            setActiveIcon("report");
            navigate("/report");
          }}
        >
          <img src={activeIcon === "report" ? ReportActive : Report} alt="report" style={{ height: "44px", cursor: "pointer" }} title="Report" />
        </div>
      {/* )} */}
    </div>
  );
};

export default Sidebar;
